import { connect } from 'react-redux'
import { reduxForm } from 'redux-form/immutable'

import { setActivityRating } from 'store/entities/identity/actions'
import UserActivityDonePanelForm from './UserActivityDonePanel'
import { USER_ACTIVITY_DONE_PANEL_FORM as FORM_NAME } from 'app/constants/activities'

const mapDispatchToProps = {
  setActivityRating,
}

const formProps = {
  form: FORM_NAME,
  onSubmit: (values, dispatch, { setActivityRating, activityId }) => {
    setActivityRating(values.set('id', activityId).toJS())
  },
}

export default connect(null, mapDispatchToProps)(reduxForm(formProps)(UserActivityDonePanelForm))
